export enum APIs {
  AP = 'AppointmentPlus',
  NOVA = 'Nova'
}
